import { Column } from '@ant-design/charts';
import React from 'react'
import { formatRupees } from '../../../../utils/formatRupees';

const WeeklyLoansChart = ({ chartData }) => {
    const config = {
        data: chartData,
        xField: 'month',
        yField: 'amount',
        color: '#B7F4B2',
        label: {
            position: 'top',
            style: {
                fill: '#129F07',
                opacity: 1,
            },
            content: (originData) => {
                return originData?.count !== 0 ? originData?.count : ''
            },
        },
        xAxis: {
            tickCount: 12,
        },
        yAxis: {
            min: 0,
            label: {
                formatter: (val) => `${val < 1000 ? '₹ ' + val : formatRupees(val)}`,
            },
            title: {
                text: 'Amount'
            },
        },
        padding: [50, 20, 20, 80],
    };
    return (
        <Column {...config} />
    )
}

export default React.memo(WeeklyLoansChart)